import * as React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
// styles

const ThemeBack = styled.div`
  height: 234px;
  width: 285px;
  background-color: #f9f9f9;
  border-radius: 6px 6px 0 0;
  &:first-child img {
    position: absolute;
    left: 50%;
    margin-left: -131px;
    top: 10px;
    /*margin-top:-100px;*/
  }
`;

// markup
const ThemeWindow = (props: { imageLink: string }) => {
  const { imageLink } = props;
  return (
    <ThemeBack>
      <img
        src={imageLink}
        width="263"
        height="198"
        alt="Rotary Opens Opportunities"
      />
    </ThemeBack>
  );
};

ThemeWindow.defaultProps = {
  imageLink: '',
};

ThemeWindow.propTypes = {
  imageLink: PropTypes.string,
};

export default ThemeWindow;
